export default "__VITE_ASSET__DshgdGd5__"